import styled from "@emotion/styled"
import { colors } from "../config/theme"

export const Button = styled.button<{
  variant?: "primary" | "secondary"
  inverse?: boolean
}>`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  padding: 14px;
  background: ${({ variant }) =>
    variant === "primary" ? colors.primary : "transparent"};
  color: ${({ variant }) =>
    variant === "primary" ? "#FFFFFF" : colors.primary};

  background: ${({ inverse }) => (inverse ? colors.white : null)};
  color: ${({ inverse }) => (inverse ? colors.primary : null)};

  flex: none;
  flex-grow: 0;
  border: 0px;
  font-family: "Arial";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 0.012em;
  cursor: pointer;
  user-select: none;

  height: fit-content;

  &:hover,
  &:active {
    background-color: ${({ variant }) =>
      variant === "primary" ? colors.black : "transparent"};
    color: ${({ variant }) =>
      variant === "primary" ? colors.white : colors.black};
  }

  &:disabled,
  &:disabled:active,
  &:disabled:hover {
    background-color: ${colors.greyMid};
    color: ${colors.white};
  }
`

Button.defaultProps = {
  variant: "primary",
  inverse: false,
}
